import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useToolbarOptions } from "../context/toolbarOptions";

const firebase = window.firebase;
const firebaseui = window.firebaseui;

const styles = {
    container: {
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
};

const LoginScreen = () => {
    const history = useHistory();
    const { setToolbarOptions } = useToolbarOptions();

    useEffect(() => {
        setToolbarOptions({ title: "Log in", items: [] });
    }, [setToolbarOptions]);

    useEffect(() => {
        const ui = new firebaseui.auth.AuthUI(firebase.auth());
        ui.start("#signin", {
            signInFlow: "popup",
            signInOptions: [
                firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                firebase.auth.FacebookAuthProvider.PROVIDER_ID,
            ],
            callbacks: {
                signInSuccessWithAuthResult: function (
                    _authResult,
                    _redirectUrl
                ) {
                    history.goBack();
                    return false;
                },
            },
        });

        return () => ui.delete();
    }, [history]);

    return (
        <div style={styles.container}>
            <div id="signin" />
        </div>
    );
};

export default LoginScreen;
